import { apiGetMe } from './common/api/profile'
import { gtmDataLayer } from 'pobble-components/dist/metrics'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { posthog } from 'posthog-js'

const onAfterFormSignup = ({ type, email, res }) => {
  posthog.capture('signed up via form', {
    email
  })
}

const onAfterFinishSignup = () => {
  return apiGetMe({
    include:
      'account.origin,account.email_identity.email,account.names,account.finish_signup_status,account.teacher_type.status,account.teacher_type.school.names,account.teacher_type.school.address,account.teacher_type.school.paid,account.teacher_type.school.paid,account.pending_teacher_type.status,account.pending_teacher_type.school.names,account.pending_teacher_type.school.address,account.pending_teacher_type.school.paid,account.pending_teacher_type.school.paid,account.student_type,account.parent_types,account.parent_type.student_type.account.names,account.parent_type.student_type.school.names,account.signup_details'
  })
    .then(res => {
      const me = res.data

      if (me.account.teacher_type || me.account.pending_teacher_type) {
        const pending = !!me.account.pending_teacher_type
        let school = me.account.pending_teacher_type
          ? me.account.pending_teacher_type.school
          : me.account.teacher_type.school
        school = school || {}
        gtmDataLayer({
          event: 'signedup',
          userId: me.account.id,
          pobble_id: me.account.id,
          account_type: 'teacher',
          account_role: me.account.role_in_life,
          school_subscribed: !!school.pobble_school,
          pending_teacher: pending
        })
      } else if (!me.account.student_type) {
        gtmDataLayer({
          event: 'signedup',
          userId: me.account.id,
          pobble_id: me.account.id,
          account_type: 'parent',
          account_role: me.account.role_in_life,
          has_child: !!me.account.parent_types.length
        })
      }
    })
    .catch(errorHandler)
}

const onSignin = ({ provider }) => {
  return apiGetMe({
    include:
      'account.origin,account.signin_details,account.signup_details,account.email_identity.email,account.names,account.finish_signup_status,account.teacher_type.status,account.teacher_type.school.names,account.teacher_type.school.address,account.teacher_type.school.paid,account.pending_teacher_type.status,account.pending_teacher_type.school.names,account.pending_teacher_type.school.address,account.pending_teacher_type.school.paid,account.student_type,account.parent_types,account.parent_type.student_type.account.names,account.parent_type.student_type.school.names,account.subscriptions'
  })
    .then(res => {
      const me = res.data
      if (!me.account.email_identity) return
      if (me.account.teacher_type || me.account.pending_teacher_type) {
        const pending = !!me.account.pending_teacher_type
        let school = me.account.pending_teacher_type
          ? me.account.pending_teacher_type.school
          : me.account.teacher_type.school
        school = school || {}

        posthog.identify(me.account.id)
        posthog.capture('signed in', {
          provider
        })

        gtmDataLayer({
          event: 'authenticated',
          userId: me.account.id,
          pobble_id: me.account.id,
          account_type: 'teacher',
          school_subscribed: !!school.pobble_school,
          pending_teacher: pending
        })
      } else if (!me.account.student_type) {
        gtmDataLayer({
          event: 'authenticated',
          userId: me.account.id,
          pobble_id: me.account.id,
          account_type: 'parent',
          has_child: !!me.account.parent_types.length
        })
      }
    })
    .catch(errorHandler)
}

const onOauthSignin = ({ provider }) => onSignin({ provider })
const onFormSignin = () => onSignin({ provider: 'form' })

const onFinishSignupStep = (me, finishSignupStatus) => {
  console.log(me, finishSignupStatus?.next_stepp?.type)
}

const EVENTS = {
  onAfterFinishSignup,
  onAfterFormSignup,
  onFormSignin,
  onOauthSignin,
  onFinishSignupStep
}

export default EVENTS
